var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2005 29.3333C23.5643 29.3333 29.5339 23.3638 29.5339 16C29.5339 8.63616 23.5643 2.66663 16.2005 2.66663C8.83672 2.66663 2.86719 8.63616 2.86719 16C2.86719 23.3638 8.83672 29.3333 16.2005 29.3333Z",
    stroke: "#D05300",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 22.6666H16.2135",
    stroke: "#D05300",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 12C12.6338 11.1089 13.2525 10.3575 14.0669 9.87887C14.8813 9.40024 15.8388 9.22528 16.7699 9.38498C17.7009 9.54467 18.5454 10.0287 19.1537 10.7514C19.7621 11.4741 20.0951 12.3887 20.0936 13.3334C20.0936 16 16.0936 17.3334 16.0936 17.3334",
    stroke: "#D05300",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.f8b95f5e.svg";
export { ForwardRef as ReactComponent };